import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EnderComunic } from "../../../interfaces/entities/MeuCadastro/EnderComunic";
import "./styles.css";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import ModalEditContact from "./ModalEditContact/ModalEditContact";

const ContactData: React.FC<{
  dadosContato: EnderComunic[];
  canChangeData: boolean;
  openModalFeedBack: (title: string, subtitle: string) => void;
  openModalSuccessNoButton: () => void;
}> = ({
  dadosContato,
  canChangeData,
  openModalFeedBack,
  openModalSuccessNoButton,
}) => {
  const {
    calculateTextStyle,
    textStyleAccessibility,
    contrastStyle,
    contrastBorderAccessibility,
  } = useAccessibility();
  const font14Style = calculateTextStyle(14);
  const [showContatoModal, setShowContatoModal] = useState<boolean>(false);

  const email = dadosContato.find((campo) => {
    return campo.tipo === "EMAIL";
  });

  const celular = dadosContato.find((campo) => {
    return campo.tipo === "CEL";
  });

  const telefone = dadosContato.find((campo) => {
    return campo.tipo === "TEL";
  });

  return (
    <div className="registration-data-card-holder">
      <div
        className="registration-data-card"
        style={{ ...contrastBorderAccessibility, ...contrastStyle }}
      >
        <div className="registration-data-row">
          <span
            style={textStyleAccessibility}
            className="registration-data-title"
          >
            Dados de contato
          </span>
        </div>
        <div
          className="registration-data-row registration-data-row-secondary"
          style={{ ...contrastBorderAccessibility, ...contrastStyle }}
        >
          <span style={font14Style} className="registration-data-key">
            E-mail
          </span>
          <span style={font14Style} className="registration-data-value">
            {email?.valor || "-"}
          </span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">
            Celular
          </span>
          <span style={font14Style} className="registration-data-value">
            {celular?.valor || "-"}
          </span>
        </div>
        <div
          className="registration-data-row registration-data-row-secondary radius-bottom"
          style={{ ...contrastBorderAccessibility, ...contrastStyle }}
        >
          <span style={font14Style} className="registration-data-key">
            Telefone
          </span>
          <span style={font14Style} className="registration-data-value">
            {telefone?.valor || "-"}
          </span>
        </div>
      </div>
      {canChangeData && (
        <button
          style={textStyleAccessibility}
          className="editar-contato-btn"
          onClick={() => setShowContatoModal(true)}
        >
          <FontAwesomeIcon icon={faEdit} /> <u> Alterar dados de contato</u>
        </button>
      )}
      <ModalEditContact
        open={showContatoModal}
        onClose={() => setShowContatoModal(false)}
        userData={{
          cel: celular?.valor ?? "",
          tel: telefone?.valor ?? "",
          email: email?.valor ?? "",
        }}
        openModalFeedBack={openModalFeedBack}
        openModalSuccessNoButton={openModalSuccessNoButton}
      />
    </div>
  );
};

export default ContactData;
